export default __webpack_public_path__ + "./images/cw.73bcfef7.png";